import React from "react";
import ReactDOM from "react-dom";
import "./assets/main.css";
import "./assets/fontawesome/css/all.css";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
